module.exports = __webpack_public_path__ + "img/QuienCorresponda.0389bdbb.gif";